import thumbnails from './thumbnails';

const products = [
    {
        "id": 1, 
        "name": "W-210 Cashew Nut",
        "thumbnailURL": thumbnails[16],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },
    {
        "id": 2,
        "name": "WW-240 Cashew Nut",
        "thumbnailURL": thumbnails[18],
        "grade": "W240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },
    {
        "id": 3,
        "name": "WW-320 Cashew Nut",
        "thumbnailURL": thumbnails[19],
        "grade": "W240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },
    {
        "id": 4,
        "name": "JH1 Cashew Nut",
        "thumbnailURL": thumbnails[3],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },
    {
        "id": 5,
        "name": "JH Cashew Nut",
        "thumbnailURL": thumbnails[4],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },
    {
        "id": 6,
        "name": "JK-1 Cashew Nut",
        "thumbnailURL": thumbnails[5],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },
    {
        "id": 7,
        "name": "JK Cashew Nut",
        "thumbnailURL": thumbnails[6],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },
    {
        "id": 8,
        "name": "LWP Cashew Nut",
        "thumbnailURL": thumbnails[7],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },
    {
        "id": 9,
        "name": "P-210 Cashew Nut",
        "thumbnailURL": thumbnails[8],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },
    {
        "id": 10,
        "name": "P-240 Cashew Nut",
        "thumbnailURL": thumbnails[9],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },
    {
        "id": 11,
        "name": "P-320 Cashew Nut",
        "thumbnailURL": thumbnails[10],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },

    {
        "id": 12,
        "name": "P-400 Cashew Nut",
        "thumbnailURL": thumbnails[11],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },

    {
        "id": 13,
        "name": "S-210 Cashew Nut",
        "thumbnailURL": thumbnails[12],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },

    {
        "id": 14,
        "name": "S-240 Cashew Nut",
        "thumbnailURL": thumbnails[13],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },

    {
        "id": 15,
        "name": "S-320 Cashew Nut",
        "thumbnailURL": thumbnails[14],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },

    {
        "id": 16,
        "name": "SWP Cashew Nut",
        "thumbnailURL": thumbnails[15],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },
    {
        "id": 17,
        "name": "Butts Cashew Nut",
        "thumbnailURL": thumbnails[0],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common"
    },
    {
        "id": 18,
        "name": "W-400 Cashew Nut",
        "thumbnailURL": thumbnails[17],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    },

    {
        "id": 19,
        "name": "DW Cashew Nut",
        "thumbnailURL": thumbnails[1],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common"
    },
    {
        "id": 20,
        "name": "JB Cashew Nut",
        "thumbnailURL": thumbnails[2],
        "grade": "WW240",
        "color": "white",
        "packagingtype": "loose",
        "processingtype": "baked",
        "brokenage": "2%",
        "cultivationtype": "common" 
    }
];

export default products;